"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isUint8Array = function isUint8Array(obj) {
  return obj instanceof Uint8Array;
};

var _default = isUint8Array;
exports["default"] = _default;